/**
 * Code by Ruby - Convx - TL-3657
 * Variant A: Cart page (original - default live version)
 * Variant B: Cart drawer
 * set window.cartABTestVariant = 'B' for the test variant
 */
(function() {
  'use strict';
  
  if (typeof window.cartABTestVariant === 'undefined') {
    window.cartABTestVariant = 'A';
  }
  
  function setVariantAttribute() {
    if (document.body) {
      document.body.setAttribute('data-cart-ab-variant', window.cartABTestVariant);
      
      // if (window.location.search.includes('debug=abtest')) {
      //   console.log('Cart A/B Test Variant:', window.cartABTestVariant);
      // }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setVariantAttribute);
  } else {
    setVariantAttribute();
  }

  window.setCartABVariant = function(variant) {
    if (variant !== 'A' && variant !== 'B') {
      // console.error('Cart AB Test: Variant must be "A" or "B"');
      return;
    }
    window.cartABTestVariant = variant;
    if (document.body) {
      document.body.setAttribute('data-cart-ab-variant', variant);
    }
    // console.log('Cart AB Test variant set to:', variant);
  };
  
  if (document.body) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-ab-variant') {
          const attrValue = document.body.getAttribute('data-cart-ab-variant');
          if (attrValue === 'A' || attrValue === 'B') {
            window.cartABTestVariant = attrValue;
          }
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-cart-ab-variant']
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-ab-variant') {
            const attrValue = document.body.getAttribute('data-cart-ab-variant');
            if (attrValue === 'A' || attrValue === 'B') {
              window.cartABTestVariant = attrValue;
            }
          }
        });
      });
      
      if (document.body) {
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ['data-cart-ab-variant']
        });
      }
    });
  }
})();